var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-input',{attrs:{"size":"medium","readonly":"","placeholder":"请输入金额"}})
}
var staticRenderFns = []

export { render, staticRenderFns }